import { ApiResponse, EventDetail, EventAllocation, UpcomingEvent, normaliseAllocationStatus } from "../models";
import apiClient from "./api/apiClient";
import { handleApiError } from "./api/apiErrorHandler";

export interface GetEventResponse extends ApiResponse {
    results: {
        event: EventDetail;
    };
}

export interface GetMyAllocationsResponse extends ApiResponse {
    results: {
        allocations: EventAllocation[];
    };
}

export interface GetUpcomingEventsResponse extends ApiResponse {
    results: {
        events: UpcomingEvent[];
    };
}

class EventService {
    async getEvent(eventId: number | string, customerId: number): Promise<GetEventResponse> {
        return await apiClient
            .get(`${this.baseUrl}/${eventId}?customer_id=${customerId}`)
            .then(
                (response) => response.data,
                (error) => handleApiError(error, "Failed to retrieve event details.")
            );
    }

    async getMyAllocations(eventId: number | string, customerId: number): Promise<GetMyAllocationsResponse> {
        return await apiClient
            .get(`${this.baseUrl}/${eventId}/my-allocations?customer_id=${customerId}`)
            .then(
                (response) => {
                    const data = response.data;
                    const allocations = data?.results?.allocations;
                    if (Array.isArray(allocations)) {
                        allocations.forEach((allocation) => {
                            allocation.status = normaliseAllocationStatus(allocation.status) ?? allocation.status;
                        });
                    }
                    return data;
                },
                (error) => handleApiError(error, "Failed to retrieve event tickets.")
            );
    }

    async getUpcomingForCustomer(customerId: number): Promise<GetUpcomingEventsResponse> {
        return await apiClient
            .get(`/customers/${customerId}/upcoming-events`)
            .then(
                (response) => response.data,
                (error) => handleApiError(error, "Failed to retrieve upcoming events.")
            );
    }

    constructor(private readonly baseUrl: string) {}
}

export const eventService = new EventService('/events');
